import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export interface IFRSQuestionDetailDTO {
  id: string;
  status: string;
  description: string | null;
  marks?: number | null;
  requirements?: string | null;
  hasSubmitted: boolean;
}

type GetIFRSQuestionResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: IFRSQuestionDetailDTO;
};

export const GetIFRSQuestionById = async (
  ifrsId: string,
  questionId: string
): Promise<GetIFRSQuestionResponse> => {
  try {
    const response = await axios.get(`/ifrs/${ifrsId}/questions/${questionId}`);
    return { data: response.data.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};

